'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openConversationForNewChannel = exports.openConversationForNewChannelAction = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _getClient = require('../../pubsub/selectors/getClient');

var _onMessageReceived = require('../../pubsub/actions/onMessageReceived');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var openConversationForNewChannelAction = exports.openConversationForNewChannelAction = (0, _reduxActions.createAction)(ActionTypes.OPEN_CONVERSATION_FOR_NEW_CHANNEL);

var openConversationForNewChannel = exports.openConversationForNewChannel = function openConversationForNewChannel(_ref) {
  var channel = _ref.channel,
      conversation = _ref.conversation,
      shouldNotifyBySound = _ref.shouldNotifyBySound;
  return function (dispatch, getState) {
    var client = (0, _getClient.getClient)(getState());
    dispatch(openConversationForNewChannelAction({
      channel: channel,
      conversation: conversation,
      shouldNotifyBySound: shouldNotifyBySound
    }));
    var promise = client.transactSubscriptions({
      toAdd: _defineProperty({}, channel, function (message) {
        return dispatch((0, _onMessageReceived.onMessageReceived)(message));
      })
    });

    promise.done();
    return promise;
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/openConversationForNewChannel.js
// module id = 345
// module chunks = 2 3